export default "__VITE_ASSET__DQTtC3Rt__"